/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button, message, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import Compress from 'react-image-file-resizer';
import BoxImage from '../../../../components/BoxImage';
import { useInspeccionContext } from '../../../../context/inspeccion-context';
import { errorHandler, heicAndheifConvert, isMobile } from '../../../../utils';
import { instanceRef } from '../../../../utils/axios';

export default function Tarjeta(props) {
  const [imagen, setImagen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [whatchid, setWatchid] = useState();
  const [xlatitud, setLatitud] = useState(0.0);
  const [ylongitud, setLongitud] = useState(0.0);
  const {
    uploadFile,
    setHasImagenesFunction,
    loadingImages
  } = useInspeccionContext();

  const { card, imagenes, inspeccion } = props;

  useEffect(() => {
    loadImage();
    getPosition();
    return function cleanup() {
      navigator.geolocation.clearWatch(whatchid);
    };
  }, [imagenes]);

  const loadImage = () => {
    if (imagenes) {
      Object.keys(imagenes).forEach(function test(key) {
        if (imagenes[key]) {
          if (imagenes[key].paso_nro === card.key) {
            setDisabled(false);
            setImagen(imagenes[key].url);
            setHasImagenesFunction(true);
          }
        }
      });
    }
  };

  const saveimage = async (file) => {
    try {
      if (isMobile) {
        setLoading(true);
        await uploadFile(file, card.key, inspeccion);
        if (xlatitud !== 0.0) {
          instanceRef.instance.post(`inspeccion/update/${inspeccion.token}`, {
            latitud: xlatitud,
            longitud: ylongitud
          });
        }
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagen(reader.result);
          // getImages(inspeccion);
          setDisabled(false);
          try {
            if (card.key === props.countPasos) {
              props.reload();
            }
          } catch (error) {
            // error
          }
        };
        setLoading(false);
        reader.readAsDataURL(file);
      } else {
        errorHandler(null, 'Debe tomar la foto desde un dispositivo móvil');
      }
    } catch (err) {
      // error
    }
  };

  const getPosition = async () => {
    if (navigator.geolocation) {
      setWatchid(
        navigator.geolocation.watchPosition(function test(position) {
          setLatitud(position.coords.latitude);
          setLongitud(position.coords.longitude);
        })
      );
    }
  };

  const customRequest = async ({ file }) => {
    const converted = await heicAndheifConvert(file);
    try {
      Compress.imageFileResizer(
        converted, // the file from input
        2400, // width
        1600, // height
        'JPEG', // compress format WEBP, JPEG, PNG
        90, // quality
        0, // rotation
        (uri) => {
          saveimage(uri);
        },
        'blob' // blob or base64 default base64
      );
    } catch (error) {
      message.error(error);
    }
  };
  const getMessage = () => {
    if (disabled) {
      return (
        <Typography.Paragraph style={{ paddingTop: 32 }}>
          Click en la imagen para tomar la fotografía
        </Typography.Paragraph>
      );
    }
    return <p />;
  };

  const getButton = () => {
    if (props.showSiguiente) {
      return (
        <Space>
          {props.back && <Button onClick={props.back}>Anterior</Button>}
          <Button type="primary" disabled={disabled} onClick={props.next}>
            Siguiente
          </Button>
        </Space>
      );
    }
    return <p />;
  };

  return (
    <>
      <BoxImage
        customRequest={customRequest}
        imagen={imagen || card.image}
        loading={loading || loadingImages}
        card={card}
      />
      {getButton()}
      {getMessage()}
    </>
  );
}
